import { AppConst } from '@/constants'
import { eventBus } from '@/utils/eventBus'

export function showUpgradeModal(): void {
  eventBus.$emit(AppConst.rootAppEvents.showUpgradeModal)
}

export function closeUpgradeModal(): void {
  eventBus.$emit(AppConst.rootAppEvents.closeUpgradeModal)
}

